import Swiper from 'swiper';
import { breakpoints } from '../conf';

export default () => {
  // variables
  const els = document.querySelectorAll('[data-material-swiper]');
  const breakpoint = window.matchMedia(`(min-width:${breakpoints.md}px)`);
  const swipers = [];

  const options = {
    slidesPerView: 'auto',
    slidesPerColumn: 2,
    spaceBetween: 15,
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    },
    navigation: {
      nextEl: '[data-material-swiper-next]',
      prevEl: '[data-material-swiper-prev]',
    },
  };

  // functions
  const enableSwipers = () => {
    if (els.length) {
      els.forEach((el) => {
        swipers.push(new Swiper(el, options));
      });
    }
  };

  const breakpointChecker = () => {
    if (breakpoint.matches === true) {
      while (swipers.length > 0) {
        if (swipers[0] !== undefined) swipers[0].destroy(true, true);
        swipers.shift();
      }
      return false;
    }
    return enableSwipers();
  };

  // init
  breakpointChecker();
  breakpoint.addListener(breakpointChecker);
};
